module.exports = __webpack_public_path__ + "img/aquila-logo.d76e26e0.svg";